import React from "react";
import AOS from "aos";
import CookieConsent from "react-cookie-consent";
import { useState } from "react";
import { useEffect } from "react";
import Home2 from "./home2";
const Home = () => {
  AOS.init({
    duration: 1200,
  });
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    const timeoutId = setTimeout(() => {}, countdown * 500);
    const countdownIntervalId = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 500);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(countdownIntervalId);
    };
  }, [countdown]);
  return (
    <div>
      <div
        className={`showLoop bg-green ${
          countdown <= 0 ? "hideLoop bg-danger" : ""
        }`}
      >
        {/* <Splash /> */}
      </div>
      <Home2 />
      <CookieConsent
        className="myConsent "
        location="bottom"
        buttonText="ACCEPT ALL"
        declineButtonText="REJECT"
        cookieName="SupervetCookie"
        onAccept={(acceptedByScrolling) => {
          if (acceptedByScrolling) {
            // triggered if user scrolls past threshold
            // alert("Accept was triggered by user scrolling");
          } else {
            // alert("Accept was triggered by clicking the Accept button");
          }
        }}
        enableDeclineButton
        onDecline={(test) => {
          console.log("userDenied cookies");
        }}
        style={{
          background: "#4A6543",
          fontFamily: "Paralucentlight",
          lineHeight: "140%",
          fontSize: "16px",
        }}
        buttonStyle={{
          backgroundColor: "#15c215",
          padding: "10px 20px",
          fontSize: "15px",
          fontFamily: "Paralucent",
          color: "white",
          borderRadius: "10px",
        }}
        declineButtonStyle={{
          borderRadius: "10px",

          padding: "10px 20px",
          backgroundColor: "white",
          fontSize: "15px",
          fontFamily: "Paralucent",
          color: "black",
        }}
        expires={150}
      >
        Extending our services and providing you with a smoother web experience
        while using our website, we may collect cookies. Cookies used by us are
        to improve your involvement with Extended Trust. Keeping due privacy and
        security measures, we deal with third party services and tools. This may
        involve the use of your information to better assist you in your
        interaction with us. While it is recommended to accept the cookie
        settings as is, we ensure your right to retain any optional data you do
        not want to share. You may choose to ignore these settings on the go.
        For further details, you may view our{" "}
        <a href="/privacy-policy" style={{ textDecoration: "underline" }}>
          Privacy Policy
        </a>
        .
      </CookieConsent>
    </div>
  );
};

export default Home;
